import React from 'react'

import { useTranslation } from '@/lib/i18n/i18n'
import SCA3D from '@/refactor/assets/icons/sca-3d.svg'
import styled from '@/styles'

import { SecureAuthIconBlock, StyledTooltip } from './CardVerificationHint.components'

interface IProps {
	mobile?: boolean
}

const TooltipWithMaxWidth = styled(({ className, ...rest }) => <StyledTooltip {...rest} tipClassName={className} />)`
	max-width: 500px !important;
`

export const CardVerificationHint: React.FC<IProps> = ({ mobile = false }) => {
	const { t } = useTranslation()

	return (
		<TooltipWithMaxWidth title={t('secure-customer-authentication-tooltip-text')}>
			<SecureAuthIconBlock data-test="3dSecureAuthIcon" src={SCA3D} mobile={mobile} />
		</TooltipWithMaxWidth>
	)
}
